import React from 'react';
import { OptionProps, components } from 'react-select';
import { FilterOptionType } from 'Book/shared';
import * as S from '../../styles';

export default (props: OptionProps<FilterOptionType, true>) => (
  <components.Option {...props}>
    <S.OptionContents>
      <S.OptionCheckbox isSelected={props.isSelected}>
        {props.isSelected && <S.OptionCheck />}
      </S.OptionCheckbox>
      <S.OptionLabel>{props.label}</S.OptionLabel>
    </S.OptionContents>
  </components.Option>
);
